import { UserDto } from './user.dto';

export class User {
    id: string;
    email: string;
    firstname: string;
    lastname: string;
    roleId: string | null;
    departmentId: string | null;
    isActive: boolean;
    lastActiveAt: Date | null;

    constructor(data: UserDto) {
        this.id = data.id;
        this.email = data.email ?? '';
        this.firstname = data.firstname ?? '';
        this.lastname = data.lastname ?? '';
        this.roleId = data.roleId;
        this.departmentId = data.departmentId;
        this.isActive = data.isActive;
        this.lastActiveAt = data.lastActiveAt ? new Date(data.lastActiveAt) : null;
    }
}
